function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;      
      cartRemove.addEventListener('click',(evt) => removeItem(data_line));
    });
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.querySelector('body').classList.add('open-drawer');
        document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter');
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        document.body.classList.remove();
        if(document.querySelector('.looks-inr.active-look')) document.querySelector('.looks-inr.active-look').classList.remove('active-look');
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-search','open-sort','open-filter','open-look');
      });
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      	document.querySelectorAll('.cart-count').forEach(function(el) {
          el.innerHTML = cart_count;
        });
      // if(cart_count>0){
      // 	document.querySelector('.cart-count').innerHTML = cart_count;
      // }else{
      // 	document.querySelector('.cart-count').innerHTML = '';
      // }
    })
    .catch(function(error) {
      console.log(error);
    })

    // freeProductSingle();

  });
}
load_cart();



// Handle click on ".item_plus"
document.addEventListener('click', function (e) {
  const plusBtn = e.target.closest('.item_plus');
  if (plusBtn) {
    const centerQty = plusBtn.nextElementSibling; // changed to next
    const input = centerQty.querySelector('input');
    input.value = +input.value + 1;

    const newLine = plusBtn.getAttribute('data-line-item');
    const newQty = plusBtn.closest('.main_qty').querySelector('input.cart_qty').value;
    addItem(newLine, newQty);
  }
});

// Handle click on ".item_minus"
document.addEventListener('click', function (e) {
  const minusBtn = e.target.closest('.item_minus');
  if (minusBtn) {
    const centerQty = minusBtn.previousElementSibling; // changed to previous
    const input = centerQty.querySelector('input');
    if (+input.value > 0) {
      input.value = +input.value - 1;
    }

    const newLine = minusBtn.getAttribute('data-line-item');
    const newQty = minusBtn.closest('.main_qty').querySelector('input.cart_qty').value;
    addItem(newLine, newQty);
  }
});


// Handle change on quantity input
document.addEventListener('change', function (e) {
  const input = e.target.closest('.center_qty .cart_qty');
  if (input) {
    const newQty = input.value;
    const centerQty = input.closest('.center_qty');
    const itemMinus = centerQty.previousElementSibling;
    const line = itemMinus?.getAttribute('data-line-item');
    if (line) {
      addItem(line, newQty);
    }
  }
});

// Add/update cart item
function addItem(newLine, newQty) {
  const data = { line: newLine, quantity: newQty };

  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      load_cart();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}




function removeItem(data_line){
  const data = {'line': data_line ,'quantity': 0 };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    load_cart();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}


// document.addEventListener("mouseup", function (e) {
//   const openRow = document.querySelector(".item-row.open-size-selector");
//   if (!openRow) return;
//   const clickPlace = openRow.querySelector(".item-var-box");
//   if (clickPlace && !clickPlace.contains(e.target)) {
//     openRow.classList.remove("open-size-selector");
//   }
// });

document.addEventListener("click", function (e) {
  if (e.target.matches(".item-var-edit span")) {
    const itemRow = e.target.closest(".item-row");
    if (!itemRow) return;
    if (!itemRow.classList.contains("loader-shown")) {
      itemRow.classList.add("open-loader", "loader-shown");
      setTimeout(() => {
        itemRow.classList.remove("open-loader");
        itemRow.classList.toggle("open-size-selector");
      }, 1000);
    } else {
      itemRow.classList.toggle("open-size-selector");
    }
  }
});



document.addEventListener("click", function (e) {
  const openRow = document.querySelector(".item-row.open-size-selector");
  if (!openRow) return;
  const editBtn = openRow.querySelector(".item-var-edit span");
  const varBox = openRow.querySelector(".item-var-box");
  if (
    editBtn && !editBtn.contains(e.target) &&
    varBox && !varBox.contains(e.target)
  ) {
    openRow.classList.remove("open-size-selector");
  }
});



document.addEventListener('click', function (e) {
  const button = e.target.closest('.item-var-box .var');
  if (button) {
    const itemRow = button.closest('.item-row');
    const dataLine = itemRow?.getAttribute('data-line');
    const newVariantId = button.getAttribute('data-id');
    itemRow.classList.remove('open-size-selector');
    if (dataLine && newVariantId) {
      switchVariant(dataLine, newVariantId);
    } else if (newVariantId) {
      addItemNew(newVariantId);
    }
  }
});
function switchVariant(dataLine, newVariantId) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      line: dataLine,
      quantity: 0
    }),
  })
    .then((res) => res.json())
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: newVariantId, quantity: 1 }]
        }),
      });
    })
    .then((res) => res.json())
    .then(() => {
      load_cart();
    })
    .catch((err) => {
      console.error('Switch Error:', err);
    });
}
function addItemNew(line) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{ id: line, quantity: 1 }]
    }),
  })
    .then((res) => res.json())
    .then(() => {
      load_cart();
    })
    .catch((err) => {
      console.error('Add Error:', err);
    });
}




// Jd Free product 

// async function freeProductSingle() {
//     const btn = document.querySelector(".fp_add");
//     if (!btn) return;

//     const freeProductId = btn.dataset.id;
//     const price = parseFloat(Shopify.currency.rate) * parseFloat(btn.dataset.price);
//     const threshold = parseFloat(btn.dataset.total);

//     const cart = await fetch('/cart.js')
//         .then(res => res.json())
//         .catch(err => console.error("Cart fetch error:", err));

//     if (!cart) return;
//     const freeItem = cart.items.find(i => i.variant_id == freeProductId);
//     const freeExists = !!freeItem;
//     if (price > threshold && freeExists) {
//         console.log("Total dropped — removing free product");
//         await fetch('/cart/change.js', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/json'
//             },
//             body: JSON.stringify({
//                 id: freeItem.key,
//                 quantity: 0
//             })
//         });
//         load_cart();
//         return;
//     }
//     if (!freeExists && price < threshold) {
//         console.log("MATCH — Adding free product");
//         await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Accept': 'application/json'
//             },
//             body: JSON.stringify({
//                 id: freeProductId,
//                 quantity: 1,
//                 properties: {
//                     free_product: true
//                 }
//             })
//         });
//         load_cart();
//         return;
//     }
// }
// freeProductSingle();